import React, { useState } from 'react'
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'

const PasswordField: React.FC<TextFieldProps> = props => {
  const [visible, setVisible] = useState(false)

  return (
    <TextField
      {...props}
      type={visible ? 'text' : 'password'}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <>
            {props.InputProps?.endAdornment}
            <InputAdornment position="end">
              <IconButton
                aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                aria-pressed={visible}
                edge="end"
                size="small"
                onMouseDown={event => event.preventDefault()}
                onClick={() => setVisible(value => !value)}
              >
                {visible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          </>
        )
      }}
    />
  )
}

export default PasswordField
